import React, { useState, useEffect } from "react";
import {Row, Container, Col, Form, Table, Button } from "react-bootstrap";
import LeftIndent from "utils/LeftIndent";
import SaveChanges from "./SaveChanges";



export default function Users(props) {
const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
 const [filteredInput, setFilteredInput] = useState("")
 const departments = ["no_department", "seo_department", "ppc_department", "both_departments", "dev_department"]
 const roles = ["nobody", "client", "employee", "specialist", "manager", "admin"]
 const formSubmitUrl = `/datapulse/organization/${props.org.id}/user-detail`;


  return (
  <Form id="organization-user-form" method="post" encType="multipart/form-data" action={formSubmitUrl}>
    <input hidden name="authenticity_token" value={authenticityToken} readOnly />
    <SaveChanges/>
    <LeftIndent>
    <Container fluid style={{ backgroundColor: "#E1E1E1", paddingLeft:"23px" }}>
      <Row className="">
       <Col className="px-5 py-4">
         <h3>User Management</h3>
       </Col>
     </Row>
     <Row className="px-5 pb-0">
      <Col xs={"auto"}>
      <div className="mb-3 pr-4 d-flex align-items-center" >
        <Form.Label className="pr-4">Filter:</Form.Label>
        <Form.Control onChange={(e) => setFilteredInput(e.target.value) } value={filteredInput} />
      </div>
      </Col>
     </Row>
     <Row>
     <Col>
          <div className="no-gutters clear-both off-color-bg show p-4">
            <div className="mb-2 table-responsive">
              <Table className="mt-2 table-white table-striped org-table">
                <thead>
                  <tr>
                    <th>ID #</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th style={{width: "200px"}}>Role</th>
                    <th  style={{width: "200px"}}>Department</th>
                    <th style={{width: "10%"}}></th>
                    { props.isOwner && <th style={{width: "10%"}}></th> }
                  </tr>
                </thead>
                <tbody>
                  {
                   Object.entries(props.org_users).map((el) => el[1]).sort((a,b) => a.id -b.id).map((user, idx) => {
                     const tempName = user.name.toLowerCase()
                     const tempEmail = user.email.toLowerCase()
                     console.log(user.role)
                     const tempRole = user.role !== "owner" ? user.role.toLowerCase().replace("_", " ") : user.role
                     const tempDepartment = !user.department ? "no_department" : user.department.toLowerCase().replace("_", " ")
                     if (tempName.includes(filteredInput.toLowerCase()) || tempEmail.includes(filteredInput.toLowerCase()) || tempDepartment.includes(filteredInput.toLowerCase()) || tempRole.includes(filteredInput.toLowerCase()) || filteredInput === "")
                     return (
                  <tr>
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      {
                        user.role === "owner" ?
                        <>
                        <p >Owner</p>
                        <input hidden name="details[]detail_role"  value={"owner"} readOnly />

                        </>
                        :

                        <Form.Control className="user-drop"size="sm" as="select" name="details[]detail_role" 
                        defaultValue={props.org_users[user.email].role} 
                        >
                          {
                             roles.map((el) => {
                               //This is formatting items such as DP_Employee and Client_Employee to remove underscores and mention of DP
                               let tempRole = el.replace("dp_", "").replace("_", " ")
                              let tempRoleFormatted = []
                              for (let i = 0; i < tempRole.length; i++) {
                               if (i === 0) {
                                 tempRoleFormatted.push(tempRole[i].toUpperCase())
                               }
                               else if (tempRole[i - 1] === " ") {
                                 tempRoleFormatted.push(tempRole[i].toUpperCase())
                               }
                               else {
                                 tempRoleFormatted.push(tempRole[i])
                                }
                          }
                          return (
                            <option value={el}>{tempRoleFormatted.join("")}</option>
                            )
                          })}    
                      </Form.Control>
                        }
                    </td>
                    <td>
                      <Form.Control className="user-drop" size="sm" as="select" name="details[]detail_department" 
                      defaultValue={props.org_users[user.email].department} 
                     >
                        <input hidden name="details[]detail_id" value={props.org_users[user.email].user_org_detail_id} readOnly />
                      {                      
                        departments.map((el) => {
                          let tempDepartment = el.replace("_", " ")
                          let tempDepartmentFormatted = []
                          for (let i = 0; i < tempDepartment.length; i++) {
                           if (i === 0) {
                             tempDepartmentFormatted.push(tempDepartment[i].toUpperCase())
                           }
                           else if (tempDepartment[i - 1] === " ") {
                             tempDepartmentFormatted.push(tempDepartment[i].toUpperCase())
                           }
                           else {
                             tempDepartmentFormatted.push(tempDepartment[i])
                           }
                          }
                          return (
                            <option value={el}>{tempDepartmentFormatted.join("")}</option>
                          )
                        })
                      }
                      </Form.Control>
                      </td>
                    <td><a  href={window.location.origin + `/datapulse/users/${user.id}`}><Button size="sm" className="view"> View User</Button></a></td>
                    { props.isOwner && <td><a><Button size="sm" className="remove"> Remove User</Button></a></td>}
                 </tr>                  
                     )})
                  }           
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
     </Row>
    </Container>
    </LeftIndent>
   </Form>
  );
}
